import { graphql, useStaticQuery } from 'gatsby';
import React, { FunctionComponent, ReactNode, useEffect } from 'react';

import { css, Global } from '@emotion/core';
// Plugins
import createFontAwesomeLibrary from '@plugins/FontAwesomeLibrary';
import Colors from '@theme/colors';

import Footer from './Footer';
import Header from './Header';

const options = {
  autoConfig: true, // set pixel's autoConfig
  debug: false, // enable logs
};

interface MainProps {
  children: ReactNode;
  location: { pathname: string; href: string };
  isSignup?: boolean;
  className?: string;
}

createFontAwesomeLibrary();

const Main: FunctionComponent<MainProps> = ({ location, children, isSignup, className }) => {
  let ReactPixel = null;
  let trialLocation = { pathname: '' };
  useEffect(() => {
    if (typeof window && window !== undefined) {
      ReactPixel = require('react-facebook-pixel').default;
      ReactPixel.init('747979788672345', options);
      ReactPixel.init('135479083840299', options);
      ReactPixel.track('PageView');
    }
  });

  if (typeof location !== 'undefined') {
    trialLocation = location;
  }

  const isRLS = trialLocation && trialLocation.pathname.includes('participants/neurology/restless-legs-syndrome-study');
  const isIndex = location
    ? location.pathname === '/participants' ||
      location.pathname === '/participants/' ||
      location.pathname.includes('participants')
    : false;
  const isDCRI = trialLocation ? trialLocation.pathname.includes('participants/rheumatology/teen-lupus-study') : false;

  const data = useStaticQuery(query);
  const TLPBackground = data.file && !isRLS ? data.file.childImageSharp.fluid.src : null;
  const showHeader = !isIndex || !isRLS || isDCRI || !isSignup;
  return (
    <>
      <Global
        styles={css`
          * {
            font-family: Lato, Helvetica;
            box-sizing: border-box;
          }
          body {
            background-image: url(${TLPBackground});
            background-position: top;
            background-repeat: no-repeat;
            background-size: 100%, 36%;
            font-family: Lato, Helvetica;
            margin: 0 auto;
            max-width: 1900px;
          }
          h1,
          h2,
          h3,
          h4,
          h5,
          p,
          b,
          div {
            color: ${Colors.neutral75};
          }
        `}
      />
      {showHeader && !isRLS && !isIndex && <Header location={location} />}
      <main className={className}>{children}</main>
      {!isIndex && <Footer location={location} />}
    </>
  );
};
const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
    file(relativePath: { eq: "tlpv2-background.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
export default Main;
